import { INVOICE_DOCUMENT_PREVIEW_VISIBLE } from '@/constants/localStorageKeys'

/**
 * This mixin provides properties and methods needed to display document preview
 */
export const DocumentPreviewViewMixin = {
  data () {
    return {
      isDocumentPreviewPanelVisible: this.getLSDocumentPreviewVisibilityState()
    }
  },
  methods: {
    toggleDocumentPreview () {
      this.isDocumentPreviewPanelVisible = !this.isDocumentPreviewPanelVisible
      localStorage.setItem(INVOICE_DOCUMENT_PREVIEW_VISIBLE, this.isDocumentPreviewPanelVisible)
    },
    /**
     * @return {boolean} the document preview visibility state stored in localStorage. When there is no record in localStorage the default value is `true`
     */
    getLSDocumentPreviewVisibilityState () {
      const isDocumentPreviewPanelVisibleLS = localStorage.getItem(INVOICE_DOCUMENT_PREVIEW_VISIBLE)
      return isDocumentPreviewPanelVisibleLS ? isDocumentPreviewPanelVisibleLS === 'true' : true
    },
    restoreDocumentPreviewVisibilityStateFromLS () {
      this.isDocumentPreviewPanelVisible = this.getLSDocumentPreviewVisibilityState()
    }
  }
}
